import { useContext } from 'react';
import { ViewerSettingsContext } from "../context/viewer-settings.js";
export const useViewerSettings = () => useContext(ViewerSettingsContext);
//# sourceMappingURL=use-viewer-settings.js.map